import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  getCanonicalUrlForRoute,
  getRobotsContentForRoute,
} from "@/lib/indexing-policy";

function ensureMeta(name: string, content: string) {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute("name", name);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

function ensureLink(rel: string, href: string) {
  let element = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", rel);
    document.head.appendChild(element);
  }
  element.setAttribute("href", href);
}

export default function IndexingPolicy() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;

    const robots = getRobotsContentForRoute(window.location.hostname, location.pathname);
    const canonical = getCanonicalUrlForRoute(window.location.hostname, location.pathname);

    ensureMeta("robots", robots);
    ensureMeta("googlebot", robots);

    if (canonical) {
      ensureLink("canonical", canonical);
    } else {
      const existing = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
      existing?.remove();
    }
  }, [location.pathname]);

  return null;
}
